module.exports = __webpack_public_path__ + "img/error.296871f1.svg";